const getSubtitlesTranslations = (t) => ({
  '100': t('page.discover.suArabic'),
  '200': t('page.discover.suEnglish'),
  '300': t('page.discover.suSpanish'),
  '400': t('page.discover.suFrench'),
  '401': t('page.discover.canadianFrench'),
  '500': t('page.discover.suChineseSimp'),
  '600': t('page.discover.suGerman'),
  '700': t('page.discover.suPolish'),
  '800': t('page.discover.suItalian'),
  '900': t('page.discover.suDutch'),
  '1000': t('page.discover.suFinnish'),
  '1100': t('page.discover.suSwedish'),
  '1200': t('page.discover.suNorwegian'),
  '1300': t('page.discover.suDanish'),
  '1400': t('page.discover.suPortuguese'),
});

export default getSubtitlesTranslations;
